import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from '@reach/router';
import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import ProjectNotFound from '../project-not-found';

const Container = styled.div`
  padding: 5px;
`;

const Details = styled.div`
  margin: 0 auto;
  max-width: 890px;

  &.oskar-blues {
    max-width: 813px;
  }
  &.spin-to-win {
    max-width: 742px;
  }
  &.lobby-link {
    max-width: 450px;
  }
  &.use-only-what-you-need-quizzes {
    max-width: 700px;
  }

  /* fix for autoplay dots */
  .slick-dots li button:focus:before {
    opacity: 0.25;
  }
  .slick-dots li.slick-active button:focus:before,
  .slick-dots li button:hover:before {
    opacity: 1;
  }
`;

const GalleryHeader = styled.div`
  overflow: auto;

  .gallery-header--info,
  .gallery-header--back {
    display: inline-block;
  }
  .gallery-header--info {
    float: left;
    max-width: 50%;
  }
  .gallery-header--info--client {
    font: 700 20px/22px 'Lato', sans-serif;
  }
  .gallery-header--info--description {
    font: 400 16px/20px 'Lato', sans-serif;
  }
  .gallery-header--back {
    float: right;
  }
  .gallery-header--back a {
    font: 700 14px/18px 'Lato', sans-serif;
    color: #428bca;
    text-decoration: none;
    transition: color 500ms ease-out;
  }
  .gallery-header--back a:hover {
    color: #000;
  }
`;

const Wrapper = styled.div`
  width: 100%;

  .slick-prev:before,
  .slick-next:before {
    color: #428bca;
    opacity: 1;
    transition: color 500ms ease-out;
  }

  .slick-prev:hover:before,
  .slick-next:hover:before {
    color: #000000;
  }
`;

var settings = {
  dots: true,
  infinite: true,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 4000,
  cssEase: 'linear',
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  fade: true
};

function ProjectDetails({ url, name }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;

    const loadData = async () => {
      const result = await axios.get(url);
      if (mounted) {
        let found = result.data.find(project => {
          return project.name === name;
        });

        const data = found !== undefined ? found : name;
        setData(data);
      }
    };
    loadData();

    return () => {
      mounted = false;
    };
  }, [url, name]);

  return (
    <Container className="page">
      {!data ? (
        <div data-testid="loading">Loading data...</div>
      ) : typeof data === 'string' ? (
        <div data-testid="resolved">
          <ProjectNotFound title={data} />
        </div>
      ) : (
        <Details data-testid="resolved" className={data.name}>
          <GalleryHeader>
            <div className="gallery-header--info">
              <div
                data-testid="client"
                className="gallery-header--info--client"
              >
                {data.client}
              </div>
              <div
                data-testid="description"
                className="gallery-header--info--description"
              >
                {data.gallery.description}
              </div>
            </div>
            <div className="gallery-header--back">
              <Link to="/" data-testid="back">
                Back to all projects
              </Link>
            </div>
          </GalleryHeader>
          <Wrapper>
            <Slider {...settings}>
              {data.gallery.images.map(image => (
                <img key={image.url} src={image.url} alt={image.alt} />
              ))}
            </Slider>
          </Wrapper>
        </Details>
      )}
    </Container>
  );
}

export default ProjectDetails;
